// Configuration file for Lushin Admin Portal
// Values are injected at build time from .env.<CLIENT> files

export const config = {
  api: {
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001',
  },
  billing: {
    baseURL: process.env.REACT_APP_BILLING_BASE_URL || 'http://localhost:8002',
  },
  frontend: {
    baseURL: process.env.REACT_APP_FRONTEND_BASE_URL || 'http://localhost:3001',
  },
  app: {
    name: process.env.REACT_APP_NAME || 'Lushin',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    logLevel: 'INFO',
  },
  auth: {
    tokenRefreshInterval: 5 * 60 * 1000,
    tokenExpiryBuffer: 60,
    /** Firebase UIDs with knowledge-base-only (super admin) access. Must stay in sync with backend/src/config/superAdmins.js */
    superAdminUids: ['xGNSfyYFhGOsFAqqsVXLGywXuW73'] as string[],
  },
  ui: {
    sidebarWidth: 260,
    defaultPageSize: 20,
  },
  tutorial: {
    disabled: process.env.REACT_APP_DISABLE_TUTORIAL === 'true',
  }
};

// Export individual configs for convenience
export const apiConfig = config.api;
export const frontendConfig = config.frontend;
export const appConfig = config.app;
export const authConfig = config.auth;
export const uiConfig = config.ui;
export const tutorialConfig = config.tutorial;
